import { Grid, Text } from '@mantine/core';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ButtonLinkWithIcon, TransButtonLinkWithIcon } from '../../Atoms/Buttons';
import { FileSize } from '../../Atoms/FileSize';
import PdfPreview from '../../Molecules/Document/PdfPreview';

const EmailFileAttachment = ({ attachment, eventId, index, deleteAtIndex }) => {
  const navigate = useNavigate();

  const styles = {
    container: {
      display: 'flex',
      alignItems: 'baseline',
      border: '1px solid rgba(0, 0, 0, .125)',
      borderRadius: 4,
      marginRight: 5,
      marginBottom: 5,
      padding: 5,
      backgroundColor: '#ffffff',
    },
    action: {
      paddingLeft: 5,
      paddingRight: 5,
    },
  };

  return (
    <div style={styles.container}>
      <Grid align="center">
        <Grid.Col span="content">
          <Text>{attachment.fileName}</Text>
          {attachment.fileSize !== undefined && Math.floor(attachment.fileSize) > 0 && (
            <FileSize fileSize={attachment.fileSize} />
          )}
        </Grid.Col>
        <Grid.Col span="content">
          {attachment.entityType === 'documents' && (
            <ButtonLinkWithIcon
              style={styles.action}
              icon="EDIT"
              onClick={() => {
                navigate(`/events/${eventId}/documents/${attachment.entityId}`);
              }}
              title=""
            />
          )}
          <PdfPreview eventId={eventId} file={attachment} button={TransButtonLinkWithIcon} />
          {deleteAtIndex && (
            <ButtonLinkWithIcon style={styles.action} icon="TRASH" onClick={() => deleteAtIndex(index)} title="" />
          )}
        </Grid.Col>
      </Grid>
    </div>
  );
};

export default EmailFileAttachment;
